module.exports = __webpack_public_path__ + "img/pc_banner_bottom.a18e9e1.webp";